export default __webpack_public_path__ + "static/media/vegetarian-caesar.21c8edf0.jpeg";